import React, { Component } from "react";
import { convertFromHTML, ContentState, EditorState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';


export default class EditorsForAddComponent extends Component {
  constructor(props) {
    super(props);
    const contentBlocks = convertFromHTML(this.props.text);
    const contentState = ContentState.createFromBlockArray(contentBlocks);

    const editorState = EditorState.createWithContent(contentState);
    this.state = {
      editorState
    };
  }
  componentDidMount() {
    if (document.querySelector(".demo-toolbar-absolute")) {
      const toolbars = document.querySelectorAll(".demo-toolbar-absolute");
      for (let i = 0; i < toolbars.length; i++) {
        toolbars[i].style.height = "0px";
        toolbars[i].style.marginTop = "-15px";
      }
    }
  }

  onEditorStateChange = editorState => {
    this.setState({
      editorState
    });
    // this.props.data.saveData(draftToHtml(convertToRaw(editorState.getCurrentContent())), this.props.data.number, this.props.data.type, this.props.editorId)
    
  };
  onContentStateChange = (contentState) => {
    // this.props.data.saveData(contentState, this.props.data.number, this.props.data.type, this.props.editorId)
    this.setState({
      contentState,
    });
  };
  onInitEditor = e => {
    const toolbar =
      e.target.parentElement.parentElement.parentElement.parentElement
        .firstChild;
    setTimeout(() => {
      if (toolbar.style.visibility == "visible") {
        toolbar.style.height = "unset";
      }
    }, 10);
  };
  onDestroy = e => {
    const toolbar =
      e.target.parentElement.parentElement.parentElement.parentElement
        .firstChild;

    setTimeout(() => {
      if (toolbar.style.visibility == "hidden") {
        toolbar.style.height = "0px";
      }
    }, 10);
  };

  render() {
    const { editorState } = this.state;
    return (
      <div className="editor-container" >
        {/* <div className="editor-delete text-white">
          <i class="fas fa-times"></i>
        </div> */}
        <Editor
          toolbarClassName="demo-toolbar-absolute"
          wrapperClassName="demo-wrapper"
          editorClassName="demo-editor"
          defaultEditorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          toolbarOnFocus
          toolbar={{
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            history: { inDropdown: true }
          }}
          onFocus={this.onInitEditor}
          onBlur={this.onDestroy}
          onContentStateChange={this.onContentStateChange}
        />
         {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        /> */}
      </div>
    );
  }
}
